import LandingPage from "./components/landing/index";
import ManualLandingPage from "./components/landing/index_manual";
import QRUpload from "./QR/QRUpload";
import './App.css';
import "./i18n";

import {
  BrowserRouter,
  Routes,
  Route,
  Navigate
} from "react-router-dom";

const redirectToWebsite = () => {
  window.location.assign('https://ilaftakaful.com/')
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/policy" element={<LandingPage />} />
        <Route path="/policy_m" element={<ManualLandingPage />} />
        <Route path="/qr_upload" element={<QRUpload />} />
        <Route path="/" element={<Navigate to="/qr_upload" replace={true} />} />
        <Route path="*" element={<Navigate to="/qr_upload" replace={true} />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
